module.exports = __webpack_public_path__ + "static/img/medal.703742ea.png";